import { cn } from '@repo/tailwind-config/tailwind.functions'
import { IFile } from '@repo/toolkit/types'
import { PropsWithChildren } from 'react'

type TransportPictoProps = {
  picto: IFile
  className?: string
}

const TransportPicto = ({ picto, className }: TransportPictoProps) => {
  return (
    <TransportPicto.Container className={className}>
      <img src={picto.path} alt={picto.name} className="w-6 h-6 rounded-full object-cover" />
    </TransportPicto.Container>
  )
}

export default TransportPicto
TransportPicto.Container = ({
  children,
  className
}: PropsWithChildren<{ className?: string }>) => {
  return (
    <div className={cn('bg-secondary-light w-fit p-1.5 rounded-sm', className)}>{children}</div>
  )
}
